@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(117_943_880)
public val Res.string.posture_pick_day: StringResource by lazy {
      StringResource("string:posture_pick_day", "posture_pick_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225621, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320729, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206324, 88),
      ))
    }

@delegate:ResourceContentHash(-994_711_694)
public val Res.string.posture_previous_week: StringResource by lazy {
      StringResource("string:posture_previous_week", "posture_previous_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225718, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320882, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206413, 49),
      ))
    }

@delegate:ResourceContentHash(42_755_594)
public val Res.string.posture_this_week: StringResource by lazy {
      StringResource("string:posture_this_week", "posture_this_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225772, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320960, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206463, 37),
      ))
    }

@delegate:ResourceContentHash(-386_967_185)
public val Res.string.presentation_source_google: StringResource by lazy {
      StringResource("string:presentation_source_google", "presentation_source_google", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225814, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321014, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206501, 54),
      ))
    }

@delegate:ResourceContentHash(1_081_538_314)
public val Res.string.presentation_source_office: StringResource by lazy {
      StringResource("string:presentation_source_office", "presentation_source_office", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225869, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321069, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206556, 58),
      ))
    }

@delegate:ResourceContentHash(939_119_279)
public val Res.string.presentation_source_prezi: StringResource by lazy {
      StringResource("string:presentation_source_prezi", "presentation_source_prezi", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225928, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321128, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206615, 41),
      ))
    }

@delegate:ResourceContentHash(-269_000_370)
public val Res.string.presentation_source_upload: StringResource by lazy {
      StringResource("string:presentation_source_upload", "presentation_source_upload", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225970, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321170, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206657, 54),
      ))
    }

@delegate:ResourceContentHash(1_852_476_307)
public val Res.string.print_action: StringResource by lazy {
      StringResource("string:print_action", "print_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226025, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321249, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206712, 28),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.print_choose_employee: StringResource by lazy {
      StringResource("string:print_choose_employee", "print_choose_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226054, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321294, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206741, 41),
      ))
    }

@delegate:ResourceContentHash(834_092_265)
public val Res.string.print_not_allowed: StringResource by lazy {
      StringResource("string:print_not_allowed", "print_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226096, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321348, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206783, 73),
      ))
    }

@delegate:ResourceContentHash(-444_913_271)
public val Res.string.print_nothing: StringResource by lazy {
      StringResource("string:print_nothing", "print_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226186, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321474, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206857, 65),
      ))
    }

@delegate:ResourceContentHash(-109_738_242)
public val Res.string.print_payroll: StringResource by lazy {
      StringResource("string:print_payroll", "print_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226448, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321824, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207071, 57),
      ))
    }

@delegate:ResourceContentHash(674_424_438)
public val Res.string.print_payroll_all: StringResource by lazy {
      StringResource("string:print_payroll_all", "print_payroll_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226260, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321580, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206923, 89),
      ))
    }

@delegate:ResourceContentHash(-1_811_188_572)
public val Res.string.print_payroll_one: StringResource by lazy {
      StringResource("string:print_payroll_one", "print_payroll_one", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226370, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321722, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207013, 57),
      ))
    }

@delegate:ResourceContentHash(1_852_476_307)
public val Res.string.print_reports: StringResource by lazy {
      StringResource("string:print_reports", "print_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226510, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321930, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207129, 29),
      ))
    }

@delegate:ResourceContentHash(-957_708_875)
public val Res.string.print_roster: StringResource by lazy {
      StringResource("string:print_roster", "print_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227288, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323056, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207799, 36),
      ))
    }

@delegate:ResourceContentHash(-995_546_013)
public val Res.string.print_roster_draft_note: StringResource by lazy {
      StringResource("string:print_roster_draft_note", "print_roster_draft_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226540, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 321976, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207159, 127),
      ))
    }

@delegate:ResourceContentHash(866_190_215)
public val Res.string.print_roster_hint: StringResource by lazy {
      StringResource("string:print_roster_hint", "print_roster_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226708, 233),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322200, 373),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207287, 201),
      ))
    }

@delegate:ResourceContentHash(-638_204_183)
public val Res.string.print_roster_one_week: StringResource by lazy {
      StringResource("string:print_roster_one_week", "print_roster_one_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 226942, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322574, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207489, 65),
      ))
    }

@delegate:ResourceContentHash(-689_852_712)
public val Res.string.print_roster_open: StringResource by lazy {
      StringResource("string:print_roster_open", "print_roster_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227016, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322676, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207555, 33),
      ))
    }

@delegate:ResourceContentHash(1_788_017_716)
public val Res.string.print_roster_ready: StringResource by lazy {
      StringResource("string:print_roster_ready", "print_roster_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227054, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322726, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207589, 110),
      ))
    }

@delegate:ResourceContentHash(-1_778_836_424)
public val Res.string.print_roster_week: StringResource by lazy {
      StringResource("string:print_roster_week", "print_roster_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227173, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322901, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207700, 33),
      ))
    }

@delegate:ResourceContentHash(-1_684_499_318)
public val Res.string.print_roster_whole_month: StringResource by lazy {
      StringResource("string:print_roster_whole_month", "print_roster_whole_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227211, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 322947, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207734, 64),
      ))
    }

@delegate:ResourceContentHash(1_548_095_742)
public val Res.string.print_scope_all: StringResource by lazy {
      StringResource("string:print_scope_all", "print_scope_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227329, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323121, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207836, 67),
      ))
    }

@delegate:ResourceContentHash(-660_091_528)
public val Res.string.print_scope_employee: StringResource by lazy {
      StringResource("string:print_scope_employee", "print_scope_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227409, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323221, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207904, 44),
      ))
    }

@delegate:ResourceContentHash(-1_763_726_540)
public val Res.string.print_scope_workplace: StringResource by lazy {
      StringResource("string:print_scope_workplace", "print_scope_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227462, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323286, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207949, 73),
      ))
    }

@delegate:ResourceContentHash(980_673_933)
public val Res.string.print_working_time: StringResource by lazy {
      StringResource("string:print_working_time", "print_working_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227532, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323388, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208023, 62),
      ))
    }

@delegate:ResourceContentHash(242_664_300)
public val Res.string.privacy_allow_selected: StringResource by lazy {
      StringResource("string:privacy_allow_selected", "privacy_allow_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227595, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323471, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208086, 50),
      ))
    }

@delegate:ResourceContentHash(-87_322_620)
public val Res.string.privacy_choices_note: StringResource by lazy {
      StringResource("string:privacy_choices_note", "privacy_choices_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227650, 144),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323546, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208137, 116),
      ))
    }

@delegate:ResourceContentHash(2_131_948_759)
public val Res.string.privacy_choices_title: StringResource by lazy {
      StringResource("string:privacy_choices_title", "privacy_choices_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227795, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323767, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208254, 69),
      ))
    }

@delegate:ResourceContentHash(5_934_718)
public val Res.string.privacy_consent_text: StringResource by lazy {
      StringResource("string:privacy_consent_text", "privacy_consent_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 227869, 444),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 323869, 764),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208324, 364),
      ))
    }

@delegate:ResourceContentHash(471_863_963)
public val Res.string.privacy_consent_title: StringResource by lazy {
      StringResource("string:privacy_consent_title", "privacy_consent_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228314, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 324634, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208689, 61),
      ))
    }

@delegate:ResourceContentHash(-757_405_785)
public val Res.string.privacy_crash_reports: StringResource by lazy {
      StringResource("string:privacy_crash_reports", "privacy_crash_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228575, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325071, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208926, 49),
      ))
    }

@delegate:ResourceContentHash(-757_507_632)
public val Res.string.privacy_crash_reports_desc: StringResource by lazy {
      StringResource("string:privacy_crash_reports_desc", "privacy_crash_reports_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228384, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 324728, 342),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208751, 174),
      ))
    }

@delegate:ResourceContentHash(2_125_612_592)
public val Res.string.privacy_not_now: StringResource by lazy {
      StringResource("string:privacy_not_now", "privacy_not_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228629, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325137, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208976, 35),
      ))
    }

@delegate:ResourceContentHash(433_046_650)
public val Res.string.privacy_usage_stats: StringResource by lazy {
      StringResource("string:privacy_usage_stats", "privacy_usage_stats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228846, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325454, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209181, 51),
      ))
    }

@delegate:ResourceContentHash(-181_730_186)
public val Res.string.privacy_usage_stats_desc: StringResource by lazy {
      StringResource("string:privacy_usage_stats_desc", "privacy_usage_stats_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228665, 180),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325181, 272),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209012, 168),
      ))
    }

@delegate:ResourceContentHash(-331_966_365)
public val Res.string.profile_business_name: StringResource by lazy {
      StringResource("string:profile_business_name", "profile_business_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228898, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325542, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209233, 49),
      ))
    }

@delegate:ResourceContentHash(903_149_455)
public val Res.string.profile_cost_summary: StringResource by lazy {
      StringResource("string:profile_cost_summary", "profile_cost_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 228944, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325608, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209283, 52),
      ))
    }

@delegate:ResourceContentHash(-515_481_110)
public val Res.string.profile_daily_total: StringResource by lazy {
      StringResource("string:profile_daily_total", "profile_daily_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229001, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325677, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209336, 51),
      ))
    }

@delegate:ResourceContentHash(1_064_483_449)
public val Res.string.profile_display_name: StringResource by lazy {
      StringResource("string:profile_display_name", "profile_display_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229061, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325757, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209388, 44),
      ))
    }

@delegate:ResourceContentHash(256_594_503)
public val Res.string.profile_monthly_total: StringResource by lazy {
      StringResource("string:profile_monthly_total", "profile_monthly_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229114, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325826, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209433, 49),
      ))
    }

@delegate:ResourceContentHash(1_069_473_103)
public val Res.string.profile_my_profile: StringResource by lazy {
      StringResource("string:profile_my_profile", "profile_my_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229164, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325896, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209483, 42),
      ))
    }

@delegate:ResourceContentHash(-714_776_954)
public val Res.string.profile_no_user_data: StringResource by lazy {
      StringResource("string:profile_no_user_data", "profile_no_user_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229207, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 325951, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209526, 52),
      ))
    }

@delegate:ResourceContentHash(-1_206_182_239)
public val Res.string.profile_photo_change: StringResource by lazy {
      StringResource("string:profile_photo_change", "profile_photo_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229284, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326052, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209579, 56),
      ))
    }

@delegate:ResourceContentHash(-476_850_297)
public val Res.string.profile_photo_choose: StringResource by lazy {
      StringResource("string:profile_photo_choose", "profile_photo_choose", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229349, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326133, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209636, 56),
      ))
    }

@delegate:ResourceContentHash(1_495_216_047)
public val Res.string.profile_photo_crop_area: StringResource by lazy {
      StringResource("string:profile_photo_crop_area", "profile_photo_crop_area", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229402, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326206, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209693, 71),
      ))
    }

@delegate:ResourceContentHash(-791_302_100)
public val Res.string.profile_photo_crop_hint: StringResource by lazy {
      StringResource("string:profile_photo_crop_hint", "profile_photo_crop_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229482, 235),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326302, 371),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209765, 167),
      ))
    }

@delegate:ResourceContentHash(478_098_519)
public val Res.string.profile_photo_crop_title: StringResource by lazy {
      StringResource("string:profile_photo_crop_title", "profile_photo_crop_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229718, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326674, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209933, 52),
      ))
    }

@delegate:ResourceContentHash(988_335_797)
public val Res.string.profile_photo_drop: StringResource by lazy {
      StringResource("string:profile_photo_drop", "profile_photo_drop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229775, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326747, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209986, 54),
      ))
    }

@delegate:ResourceContentHash(258_735_888)
public val Res.string.profile_photo_not_an_image: StringResource by lazy {
      StringResource("string:profile_photo_not_an_image", "profile_photo_not_an_image", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229834, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326818, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210041, 122),
      ))
    }

@delegate:ResourceContentHash(582_770_414)
public val Res.string.profile_photo_preparing: StringResource by lazy {
      StringResource("string:profile_photo_preparing", "profile_photo_preparing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 229961, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 326981, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210164, 59),
      ))
    }

@delegate:ResourceContentHash(-106_338_260)
public val Res.string.profile_photo_read_failed: StringResource by lazy {
      StringResource("string:profile_photo_read_failed", "profile_photo_read_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230025, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327061, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210224, 89),
      ))
    }

@delegate:ResourceContentHash(-1_685_083_980)
public val Res.string.profile_photo_refused: StringResource by lazy {
      StringResource("string:profile_photo_refused", "profile_photo_refused", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230131, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327199, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210314, 113),
      ))
    }

@delegate:ResourceContentHash(-1_414_813_871)
public val Res.string.profile_photo_remove: StringResource by lazy {
      StringResource("string:profile_photo_remove", "profile_photo_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230323, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327435, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210490, 44),
      ))
    }

@delegate:ResourceContentHash(945_566_273)
public val Res.string.profile_photo_removed: StringResource by lazy {
      StringResource("string:profile_photo_removed", "profile_photo_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230253, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327349, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210428, 61),
      ))
    }

@delegate:ResourceContentHash(-1_742_328_191)
public val Res.string.profile_photo_reset: StringResource by lazy {
      StringResource("string:profile_photo_reset", "profile_photo_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230372, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327500, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210535, 43),
      ))
    }

@delegate:ResourceContentHash(1_602_537_038)
public val Res.string.profile_photo_take: StringResource by lazy {
      StringResource("string:profile_photo_take", "profile_photo_take", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230420, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327560, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210579, 42),
      ))
    }

@delegate:ResourceContentHash(-1_934_319_059)
public val Res.string.profile_photo_too_large: StringResource by lazy {
      StringResource("string:profile_photo_too_large", "profile_photo_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230467, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327619, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210622, 107),
      ))
    }

@delegate:ResourceContentHash(2_041_601_219)
public val Res.string.profile_photo_unreadable: StringResource by lazy {
      StringResource("string:profile_photo_unreadable", "profile_photo_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230575, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327743, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210730, 104),
      ))
    }

@delegate:ResourceContentHash(415_628_885)
public val Res.string.profile_photo_updated: StringResource by lazy {
      StringResource("string:profile_photo_updated", "profile_photo_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230704, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327900, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210835, 61),
      ))
    }

@delegate:ResourceContentHash(-346_662_386)
public val Res.string.profile_photo_upload_failed: StringResource by lazy {
      StringResource("string:profile_photo_upload_failed", "profile_photo_upload_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230782, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 327986, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210897, 127),
      ))
    }

@delegate:ResourceContentHash(1_938_269_674)
public val Res.string.profile_photo_uploading: StringResource by lazy {
      StringResource("string:profile_photo_uploading", "profile_photo_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230922, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328182, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211025, 63),
      ))
    }

@delegate:ResourceContentHash(1_065_462_880)
public val Res.string.profile_photo_zoom_in: StringResource by lazy {
      StringResource("string:profile_photo_zoom_in", "profile_photo_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 230986, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328262, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211089, 41),
      ))
    }

@delegate:ResourceContentHash(-926_874_641)
public val Res.string.profile_photo_zoom_out: StringResource by lazy {
      StringResource("string:profile_photo_zoom_out", "profile_photo_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231028, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328316, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211131, 42),
      ))
    }

@delegate:ResourceContentHash(-419_570_093)
public val Res.string.profile_save_changes: StringResource by lazy {
      StringResource("string:profile_save_changes", "profile_save_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231071, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328371, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211174, 44),
      ))
    }

@delegate:ResourceContentHash(401_494_746)
public val Res.string.profile_sign_out: StringResource by lazy {
      StringResource("string:profile_sign_out", "profile_sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231120, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328436, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211219, 36),
      ))
    }

@delegate:ResourceContentHash(-527_003_332)
public val Res.string.profile_update_partial: StringResource by lazy {
      StringResource("string:profile_update_partial", "profile_update_partial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231161, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328477, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211256, 90),
      ))
    }

@delegate:ResourceContentHash(1_681_465_517)
public val Res.string.profile_updated: StringResource by lazy {
      StringResource("string:profile_updated", "profile_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231272, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328624, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211347, 47),
      ))
    }

@delegate:ResourceContentHash(1_184_327_233)
public val Res.string.profile_yearly_total: StringResource by lazy {
      StringResource("string:profile_yearly_total", "profile_yearly_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231328, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328692, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211395, 48),
      ))
    }

@delegate:ResourceContentHash(2_084_283_692)
public val Res.string.qr_camera_denied: StringResource by lazy {
      StringResource("string:qr_camera_denied", "qr_camera_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231369, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 328753, 292),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211444, 152),
      ))
    }

@delegate:ResourceContentHash(1_068_653_708)
public val Res.string.qr_not_a_tablet_code: StringResource by lazy {
      StringResource("string:qr_not_a_tablet_code", "qr_not_a_tablet_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231538, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329046, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211597, 76),
      ))
    }

@delegate:ResourceContentHash(-107_088_245)
public val Res.string.qr_offline: StringResource by lazy {
      StringResource("string:qr_offline", "qr_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231615, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329135, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211674, 90),
      ))
    }

@delegate:ResourceContentHash(-472_614_964)
public val Res.string.qr_result_break_end: StringResource by lazy {
      StringResource("string:qr_result_break_end", "qr_result_break_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231718, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329318, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211765, 55),
      ))
    }

@delegate:ResourceContentHash(1_372_649_669)
public val Res.string.qr_result_break_start: StringResource by lazy {
      StringResource("string:qr_result_break_start", "qr_result_break_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231782, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329406, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211821, 57),
      ))
    }

@delegate:ResourceContentHash(159_593_775)
public val Res.string.qr_result_in: StringResource by lazy {
      StringResource("string:qr_result_in", "qr_result_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231848, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329488, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211879, 48),
      ))
    }

@delegate:ResourceContentHash(-856_790_325)
public val Res.string.qr_result_out: StringResource by lazy {
      StringResource("string:qr_result_out", "qr_result_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231905, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329553, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211928, 49),
      ))
    }

@delegate:ResourceContentHash(98_253_087)
public val Res.string.qr_scan_break_button: StringResource by lazy {
      StringResource("string:qr_scan_break_button", "qr_scan_break_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 231963, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329627, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211978, 76),
      ))
    }

@delegate:ResourceContentHash(1_859_973_132)
public val Res.string.qr_scan_button: StringResource by lazy {
      StringResource("string:qr_scan_button", "qr_scan_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232040, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329744, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212055, 54),
      ))
    }

@delegate:ResourceContentHash(738_411_215)
public val Res.string.qr_scan_cancel: StringResource by lazy {
      StringResource("string:qr_scan_cancel", "qr_scan_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232095, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329823, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212110, 30),
      ))
    }

@delegate:ResourceContentHash(-234_754_505)
public val Res.string.qr_scan_title: StringResource by lazy {
      StringResource("string:qr_scan_title", "qr_scan_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232126, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329870, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212141, 37),
      ))
    }

@delegate:ResourceContentHash(1_999_189_222)
public val Res.string.qr_scanner_unavailable: StringResource by lazy {
      StringResource("string:qr_scanner_unavailable", "qr_scanner_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232168, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 329924, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212179, 122),
      ))
    }

@delegate:ResourceContentHash(868_671_560)
public val Res.string.recommend_copied: StringResource by lazy {
      StringResource("string:recommend_copied", "recommend_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232299, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 330131, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212302, 104),
      ))
    }

@delegate:ResourceContentHash(584_177_577)
public val Res.string.recommend_copy: StringResource by lazy {
      StringResource("string:recommend_copy", "recommend_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232420, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 330308, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212407, 38),
      ))
    }

@delegate:ResourceContentHash(-1_401_219_222)
public val Res.string.recommend_intro: StringResource by lazy {
      StringResource("string:recommend_intro", "recommend_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232467, 267),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 330391, 419),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212446, 231),
      ))
    }

@delegate:ResourceContentHash(-856_911_290)
public val Res.string.recommend_message: StringResource by lazy {
      StringResource("string:recommend_message", "recommend_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232783, 269),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 330875, 429),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212722, 269),
      ))
    }

@delegate:ResourceContentHash(1_940_008_672)
public val Res.string.recommend_message_label: StringResource by lazy {
      StringResource("string:recommend_message_label", "recommend_message_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 232735, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 330811, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212678, 43),
      ))
    }

@delegate:ResourceContentHash(-1_674_393_807)
public val Res.string.recommend_privacy: StringResource by lazy {
      StringResource("string:recommend_privacy", "recommend_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233053, 157),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 331305, 245),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212992, 117),
      ))
    }

@delegate:ResourceContentHash(-1_057_151_142)
public val Res.string.recommend_prompt_action: StringResource by lazy {
      StringResource("string:recommend_prompt_action", "recommend_prompt_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233211, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 331551, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213110, 43),
      ))
    }

@delegate:ResourceContentHash(2_125_612_592)
public val Res.string.recommend_prompt_dismiss: StringResource by lazy {
      StringResource("string:recommend_prompt_dismiss", "recommend_prompt_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233251, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 331607, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213154, 44),
      ))
    }

@delegate:ResourceContentHash(1_932_284_201)
public val Res.string.recommend_prompt_text: StringResource by lazy {
      StringResource("string:recommend_prompt_text", "recommend_prompt_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233296, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 331660, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213199, 153),
      ))
    }

@delegate:ResourceContentHash(-485_028_104)
public val Res.string.recommend_prompt_title: StringResource by lazy {
      StringResource("string:recommend_prompt_title", "recommend_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233442, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 331878, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213353, 82),
      ))
    }

@delegate:ResourceContentHash(768_043_805)
public val Res.string.recommend_row_hint: StringResource by lazy {
      StringResource("string:recommend_row_hint", "recommend_row_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233545, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332045, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213436, 74),
      ))
    }

@delegate:ResourceContentHash(-1_521_099_470)
public val Res.string.recommend_share: StringResource by lazy {
      StringResource("string:recommend_share", "recommend_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233616, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332172, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213511, 31),
      ))
    }

@delegate:ResourceContentHash(-620_759_790)
public val Res.string.recommend_subject: StringResource by lazy {
      StringResource("string:recommend_subject", "recommend_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233656, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332224, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213543, 73),
      ))
    }

@delegate:ResourceContentHash(343_437_004)
public val Res.string.recommend_title: StringResource by lazy {
      StringResource("string:recommend_title", "recommend_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233722, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332310, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213617, 75),
      ))
    }

@delegate:ResourceContentHash(-617_292_100)
public val Res.string.remote_badge: StringResource by lazy {
      StringResource("string:remote_badge", "remote_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233790, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332410, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213693, 28),
      ))
    }

@delegate:ResourceContentHash(1_646_313_587)
public val Res.string.report_absences: StringResource by lazy {
      StringResource("string:report_absences", "report_absences", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233823, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332455, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213722, 43),
      ))
    }

@delegate:ResourceContentHash(1_361_893_366)
public val Res.string.report_col_clocked: StringResource by lazy {
      StringResource("string:report_col_clocked", "report_col_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233875, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332523, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213766, 50),
      ))
    }

@delegate:ResourceContentHash(879_716_839)
public val Res.string.report_col_date: StringResource by lazy {
      StringResource("string:report_col_date", "report_col_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233930, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332586, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213817, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString28Resources(map: MutableMap<String, StringResource>) {
  map.put("posture_pick_day", Res.string.posture_pick_day)
  map.put("posture_previous_week", Res.string.posture_previous_week)
  map.put("posture_this_week", Res.string.posture_this_week)
  map.put("presentation_source_google", Res.string.presentation_source_google)
  map.put("presentation_source_office", Res.string.presentation_source_office)
  map.put("presentation_source_prezi", Res.string.presentation_source_prezi)
  map.put("presentation_source_upload", Res.string.presentation_source_upload)
  map.put("print_action", Res.string.print_action)
  map.put("print_choose_employee", Res.string.print_choose_employee)
  map.put("print_not_allowed", Res.string.print_not_allowed)
  map.put("print_nothing", Res.string.print_nothing)
  map.put("print_payroll", Res.string.print_payroll)
  map.put("print_payroll_all", Res.string.print_payroll_all)
  map.put("print_payroll_one", Res.string.print_payroll_one)
  map.put("print_reports", Res.string.print_reports)
  map.put("print_roster", Res.string.print_roster)
  map.put("print_roster_draft_note", Res.string.print_roster_draft_note)
  map.put("print_roster_hint", Res.string.print_roster_hint)
  map.put("print_roster_one_week", Res.string.print_roster_one_week)
  map.put("print_roster_open", Res.string.print_roster_open)
  map.put("print_roster_ready", Res.string.print_roster_ready)
  map.put("print_roster_week", Res.string.print_roster_week)
  map.put("print_roster_whole_month", Res.string.print_roster_whole_month)
  map.put("print_scope_all", Res.string.print_scope_all)
  map.put("print_scope_employee", Res.string.print_scope_employee)
  map.put("print_scope_workplace", Res.string.print_scope_workplace)
  map.put("print_working_time", Res.string.print_working_time)
  map.put("privacy_allow_selected", Res.string.privacy_allow_selected)
  map.put("privacy_choices_note", Res.string.privacy_choices_note)
  map.put("privacy_choices_title", Res.string.privacy_choices_title)
  map.put("privacy_consent_text", Res.string.privacy_consent_text)
  map.put("privacy_consent_title", Res.string.privacy_consent_title)
  map.put("privacy_crash_reports", Res.string.privacy_crash_reports)
  map.put("privacy_crash_reports_desc", Res.string.privacy_crash_reports_desc)
  map.put("privacy_not_now", Res.string.privacy_not_now)
  map.put("privacy_usage_stats", Res.string.privacy_usage_stats)
  map.put("privacy_usage_stats_desc", Res.string.privacy_usage_stats_desc)
  map.put("profile_business_name", Res.string.profile_business_name)
  map.put("profile_cost_summary", Res.string.profile_cost_summary)
  map.put("profile_daily_total", Res.string.profile_daily_total)
  map.put("profile_display_name", Res.string.profile_display_name)
  map.put("profile_monthly_total", Res.string.profile_monthly_total)
  map.put("profile_my_profile", Res.string.profile_my_profile)
  map.put("profile_no_user_data", Res.string.profile_no_user_data)
  map.put("profile_photo_change", Res.string.profile_photo_change)
  map.put("profile_photo_choose", Res.string.profile_photo_choose)
  map.put("profile_photo_crop_area", Res.string.profile_photo_crop_area)
  map.put("profile_photo_crop_hint", Res.string.profile_photo_crop_hint)
  map.put("profile_photo_crop_title", Res.string.profile_photo_crop_title)
  map.put("profile_photo_drop", Res.string.profile_photo_drop)
  map.put("profile_photo_not_an_image", Res.string.profile_photo_not_an_image)
  map.put("profile_photo_preparing", Res.string.profile_photo_preparing)
  map.put("profile_photo_read_failed", Res.string.profile_photo_read_failed)
  map.put("profile_photo_refused", Res.string.profile_photo_refused)
  map.put("profile_photo_remove", Res.string.profile_photo_remove)
  map.put("profile_photo_removed", Res.string.profile_photo_removed)
  map.put("profile_photo_reset", Res.string.profile_photo_reset)
  map.put("profile_photo_take", Res.string.profile_photo_take)
  map.put("profile_photo_too_large", Res.string.profile_photo_too_large)
  map.put("profile_photo_unreadable", Res.string.profile_photo_unreadable)
  map.put("profile_photo_updated", Res.string.profile_photo_updated)
  map.put("profile_photo_upload_failed", Res.string.profile_photo_upload_failed)
  map.put("profile_photo_uploading", Res.string.profile_photo_uploading)
  map.put("profile_photo_zoom_in", Res.string.profile_photo_zoom_in)
  map.put("profile_photo_zoom_out", Res.string.profile_photo_zoom_out)
  map.put("profile_save_changes", Res.string.profile_save_changes)
  map.put("profile_sign_out", Res.string.profile_sign_out)
  map.put("profile_update_partial", Res.string.profile_update_partial)
  map.put("profile_updated", Res.string.profile_updated)
  map.put("profile_yearly_total", Res.string.profile_yearly_total)
  map.put("qr_camera_denied", Res.string.qr_camera_denied)
  map.put("qr_not_a_tablet_code", Res.string.qr_not_a_tablet_code)
  map.put("qr_offline", Res.string.qr_offline)
  map.put("qr_result_break_end", Res.string.qr_result_break_end)
  map.put("qr_result_break_start", Res.string.qr_result_break_start)
  map.put("qr_result_in", Res.string.qr_result_in)
  map.put("qr_result_out", Res.string.qr_result_out)
  map.put("qr_scan_break_button", Res.string.qr_scan_break_button)
  map.put("qr_scan_button", Res.string.qr_scan_button)
  map.put("qr_scan_cancel", Res.string.qr_scan_cancel)
  map.put("qr_scan_title", Res.string.qr_scan_title)
  map.put("qr_scanner_unavailable", Res.string.qr_scanner_unavailable)
  map.put("recommend_copied", Res.string.recommend_copied)
  map.put("recommend_copy", Res.string.recommend_copy)
  map.put("recommend_intro", Res.string.recommend_intro)
  map.put("recommend_message", Res.string.recommend_message)
  map.put("recommend_message_label", Res.string.recommend_message_label)
  map.put("recommend_privacy", Res.string.recommend_privacy)
  map.put("recommend_prompt_action", Res.string.recommend_prompt_action)
  map.put("recommend_prompt_dismiss", Res.string.recommend_prompt_dismiss)
  map.put("recommend_prompt_text", Res.string.recommend_prompt_text)
  map.put("recommend_prompt_title", Res.string.recommend_prompt_title)
  map.put("recommend_row_hint", Res.string.recommend_row_hint)
  map.put("recommend_share", Res.string.recommend_share)
  map.put("recommend_subject", Res.string.recommend_subject)
  map.put("recommend_title", Res.string.recommend_title)
  map.put("remote_badge", Res.string.remote_badge)
  map.put("report_absences", Res.string.report_absences)
  map.put("report_col_clocked", Res.string.report_col_clocked)
  map.put("report_col_date", Res.string.report_col_date)
}
